import React from "react";
import { useState,useEffect } from "react";
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
 import Loading from './Loading';

function ViewSalespersonDashboard  ()  {
   const [count, setTaskCount] = useState(false);
   const app_url = configData.APP_URL;
  useEffect(() => {
      gettaskcount();
       
      },[]);
      async function gettaskcount() {
     
           try {
              const response = await fetch(
                 app_url+'smwwtask/gettaskcount',
                  {
                      method: "GET",
    
                      headers: {
                          'Content-Type': 'application/json',
                      },
                  }
              )
              const responsedata = await response.json();
              if(responsedata.data) {
                  setTaskCount(responsedata.data.result);
                 
              } 
          } catch (err) {
              
           }
         
    }
    return (
        
 <div className="dp-style">
          <div><hr className='user-profile-hori-line'></hr></div>
          <div class="col-md-12 pending-task-alert">You are having {count} Pending Task in your "My Task" list.
	   Please <a href="/my_sales_tasks?start_date=2019-10-24&amp;end_date=2025-06-15">click here</a> to view your pending task list.
	   </div>
      
          <div className="row">
              <div className="col-md-4">
                <div className="panel panel-default">
                  <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                    <b>Agents, Athletes &amp; Scouts</b>
                  </div>
                  <div className="panel-body">
                    <ul className="fl-sub">
                      <li><a href="/add_athlete">Add Athlete</a></li> 
						          <li><a href="/admin/people/create">Add User</a></li>
						          <li><a href="/agents-directory">Agent Directory</a></li>
                      <li><a href="/pending_athletes">Athletes Looking for an Agent</a></li>          
                      <li><a href="/scouts-directory">Scouts Directory</a></li>
                      <li><a href="/view/scouting-requests">View Scouting Requests</a></li>
						        </ul>
                  </div>
                </div>
              </div>
		        <div className="col-md-4">
              <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>Reports</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
                    <li><a href="/admin/reports/apps_by_country">Apps by Country Report</a></li>
						        {/* <li><a href="/subscription/payment/cancelled">Cancelled Payments Report</a></li>  */}
                    <li><a href="/admin/reports/courses-payments">Payments Report</a></li>
						        <li><a href="/admin/reports/sales_details_new">Payments Comparison Report</a></li>
                    <li><a href="/admin/reports/refererrer_bonus">Referrals Report</a></li>
                    <li><a href="/admin/reports/sort_flag">Sort Flags Report</a></li>
						        <li><a href="/user-advance-search">User Advanced Search Report</a></li>
                  </ul>
                </div>
              </div>
              <div className="panel panel-default">
                <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                  <b>People</b>
                </div>
                <div className="panel-body">
                  <ul className="fl-sub">
					          <li><a href="/saadmin-people">Manage People</a></li>  
					          <li><a href="/importer/rolodex">Rolodex Importer</a></li>
                  </ul>
                </div>
              </div>
          </div>
		      <div className="col-md-4">
            <div className="panel panel-default">
              <div className="panel-heading" style={{ backgroundColor: '#fff' }}>
                <b>Operations</b>
              </div>
              <div className="panel-body">
                <ul className="fl-sub">
                  <li><a href="/importer/application">Application Importer</a></li>
                  <li><a href="/manage-emails">Manage Emails</a></li>
                  <li><a href="/sortflags">Manage Sort Flags</a></li>
                  <li><a href="/my_sales_tasks">My Tasks</a></li>
                  <li><a href="/draft-divvy">Run App Divvy For Draft</a></li>
						      <li><a href="/salesperson/create/application">Quick Add New Person</a></li>
                  <li><a href="/app-list">View All Applications</a></li>
						      <li><a href="/course_code_key">View Course Code Key</a></li>
                </ul>
              </div>
            </div>
			    </div>
      </div>
    </div>
     )}

export default ViewSalespersonDashboard